import { useEffect, useState } from "react"
import { getPeriodRowCel } from "./get-period-row-cel"
import { getDefaultRowCel } from "./get-default-row-cel"
import { getPeriodMonthsRowCel } from "./get-period-months-row-cel"
import { getDeliveryDateRowCel } from "./get-delivery-date-row-cel"
import { getTotalBudgetedRowCel } from "./get-total-budgeted-row-cel"
import { getInvestmentByInvestors } from "./get-investment-by-invertors"
import { getRevisionRowCel } from "./get-revision-row-cel"

export const useMinistrationsTableRows = ({ ministrationsPlan, ministrationPeriods }) => {
  const [ministrationRows, setMinistrationRows] = useState([])
  const [investorsRows, setInvestorsRows] = useState([])

  const getData = () => {
    return MINISTRATION_ROWS.map(({ status }) => {
      if (status === "Periodo")
        return getPeriodRowCel(ministrationPeriods, status)

      if ("Total presupuestado".includes(status)) {
        return getTotalBudgetedRowCel(ministrationPeriods, status)
      }

      if ("Meses del periodo a ministrar".includes(status)) {
        return getPeriodMonthsRowCel(ministrationPeriods, status)
      }

      if ("Fecha de entrega de info".includes(status)) {
        return getDeliveryDateRowCel(ministrationPeriods, status, ministrationsPlan)
      }

      if ("Revisión" === status) {
        return getRevisionRowCel(ministrationPeriods, status)
      }

      return getDefaultRowCel(ministrationPeriods, status)
    })
  }

  useEffect(() => {
    if (!ministrationPeriods) return
    const newMinistrationRows = getData()
    setMinistrationRows(newMinistrationRows)

    const newInvestorsRows = getInvestmentByInvestors(ministrationPeriods)
    setInvestorsRows(newInvestorsRows)
  }, [ministrationsPlan, ministrationPeriods])

  return { ministrationRows, investorsRows }
}

const MINISTRATION_ROWS = [
  { status: "Periodo" },
  { status: "Meses del periodo a ministrar" },
  { status: "Fecha de entrega de info" },
  { status: "Revisión" },
  { status: "Fecha de orden de pago" },
  { status: "Total presupuestado" }
]
